module.exports = __webpack_public_path__ + "static/media/loading-purple.858aef29.svg";